import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES_SIGN: MijnRoute = {
    path: 'sign',
    navigationEvent: 'toBetaalbatchesSign',
    regex: /^\/betaalbatches\/sign$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent',
    internalPath: '/sign'
};
